/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
function plural(val) {
  const n = val,
    i = Math.floor(Math.abs(val));
  if (i === 0 || n === 1) return 1;
  return 5;
}
export default ["gu", [["AM", "PM"], u, u], u, [["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"], ["રવિ", "સોમ", "મંગળ", "બુધ", "ગુરુ", "શુક્ર", "શનિ"], ["રવિવાર", "સોમવાર", "મંગળવાર", "બુધવાર", "ગુરુવાર", "શુક્રવાર", "શનિવાર"], ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"]], u, [["જા", "ફે", "મા", "એ", "મે", "જૂ", "જુ", "ઑ", "સ", "ઑ", "ન", "ડિ"], ["જાન્યુ", "ફેબ્રુ", "માર્ચ", "એપ્રિલ", "મે", "જૂન", "જુલાઈ", "ઑગસ્ટ", "સપ્ટે", "ઑક્ટો", "નવે", "ડિસે"], ["જાન્યુઆરી", "ફેબ્રુઆરી", "માર્ચ", "એપ્રિલ", "મે", "જૂન", "જુલાઈ", "ઑગસ્ટ", "સપ્ટેમ્બર", "ઑક્ટોબર", "નવેમ્બર", "ડિસેમ્બર"]], u, [["ઇ સ પુ", "ઇસ"], ["ઈ.સ.પૂર્વે", "ઈ.સ."], ["ઈસવીસન પૂર્વે", "ઇસવીસન"]], 0, [0, 0], ["d/M/yy", "d MMM, y", "d MMMM, y", "EEEE, d MMMM, y"], ["hh:mm a", "hh:mm:ss a", "hh:mm:ss a z", "hh:mm:ss a zzzz"], ["{1} {0}", u, "{1} એ {0} વાગ્યે", u], [".", ",", ";", "%", "+", "-", "E", "×", "‰", "∞", "NaN", ":"], ["#,##,##0.###", "#,##,##0%", "¤#,##,##0.00", "[#E0]"], "INR", "₹", "ભારતીય રૂપિયા", {
  "BYN": [u, "р."],
  "JPY": ["JP¥", "¥"],
  "MUR": [u, "રૂ."],
  "PHP": [u, "₱"],
  "THB": ["฿"],
  "TWD": ["NT$"],
  "USD": ["US$", "$"]
}, "ltr", plural];
